var $6e844e0c7d803f63$exports = {};
$6e844e0c7d803f63$exports = {
    "pending": `\u{10D}ek\xe1 na vy\u{159}\xedzen\xed`
};


export {$6e844e0c7d803f63$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
